import Switch from './SearchSwitch';

export {
    Switch as default,
};



// WEBPACK FOOTER //
// ./src/js/Search/Switch/index.js